// Generated by `npm run supportedBrowsers`
// Do not edit manually
export const supportedBrowsers =
  /Edge?\/(13[1-9]|1[4-9]\d|[2-9]\d\d|\d{4,})\.\d+(\.\d+|)|Chrom(ium|e)\/(13[1-9]|1[4-9]\d|[2-9]\d\d|\d{4,})\.\d+(\.\d+|)/;
